import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Image from 'next/image';
import { pxToRem } from '@/util';
import { AppColors } from '@/assets/colors';
import downloadFile from '@/util/services/downloadfile';
type props={
    color:string,
    icon:string,
    data:string[],
    head:string
}
export default function Facdoc({color,icon,data,head}:Partial<props>) {
    const {classes}=styles();
  return (
    <Paper className={`${classes.container}`}>
           <Typography className={`${classes.head}`}>{head}</Typography>
           {data&&data?.map((value,key)=>{
            return(
            <Box className={`${classes.sub}`} key={key}>
            <IconButton onClick={()=>downloadFile(value,"document")}><Image src={icon||'/images/overview/pdf-icon.svg'} alt="print" width={16} height={16}/></IconButton>
            <Tooltip title={value} arrow>
              <Typography 
              className={`${classes.desc}`} 
              sx={{ color: color }} 
              noWrap 
              >
              {value}
              </Typography>
            </Tooltip>
           </Box>
            )
           })}
    </Paper>
  )
}

const styles=makeStyles()((theme)=>({
    container:{
    display:'flex',
    flexDirection:'column',
    gap:theme.spacing(3),
    padding:theme.spacing(3) ,
    }, 

   debug:{
    border:'1px solid green'
   },
   
   sub:{
     width:'100%',
    display:'flex',
    flexDirection:'row',
    gap:theme.spacing(2),
    alignItems:'center'
   },
   desc:{
    fontWeight: 400,
    fontSize: pxToRem(16),
    maxWidth: '20ch', 
    overflow: 'hidden',
     textOverflow: 'ellipsis' 
   },
   head:{
  fontWeight: 700,
  fontSize:pxToRem(20),
  color:AppColors.secondary['450']

   }
}))